// # Schematics

define('modules/Schematics/Schematics',[
    'jquery',
    'global/all',
], function ($, Roc) {
    'use strict';

    var userId;
    var redirectPage;
        
    function deleteSchematic(data) {
        $.proxyRequest({
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: '/api/schematics/delete/' + data + '/',
            complete: function (xhr) {
                Roc.Logger.info('Schematics -> removeSchematics');
                var response = xhr.responseJSON || {};
                if (!response.isSuccess) {
                    Roc.UI.error('There was problems deleting this schematic, please try again!');
                } else {
                    Roc.UI.info('Schematic Deleted successfully');
                    window.location = redirectPage;
                }
            }
        });
    }

    function getItemData(element, attr) {
        return $(element).parents('.itemWrapper').attr('data-' + attr);
    }
   
    function deleteSchematicEvt() {
        $(document).on('click', '.deleteShematicItemBtn', function () {
            Roc.UI.confirm('Are you sure you want to remove this schematic?', $.proxy(function () {
                var schematicId = getItemData(this, 'schematic-id');
                deleteSchematic(schematicId);
            }, this));
        });
    }

    function bindEvents() {
        if (bindEvents.COMPLETED) {
            return;
        }

        //Roc.Config.loadConfig().then(function () {
            deleteSchematicEvt();
            bindEvents.COMPLETED = true;
        //});
    }

    function init(options) {
        bindEvents();
        userId = options.UserId;
        redirectPage = options.RedirectPage;
    };

    var Schematics = {
        init: init
    }

    Roc.Logger.debug('Schematics.js Loaded:', Schematics);

    return Schematics;
});
